module.exports = __webpack_public_path__ + "img/120.183dd4f4.gif";